import AddButton from "components/Button/AddButton";
import React, { useEffect, useState } from "react";
import TrashIcon from "assets/icon/TrashIcon";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, DropdownStatusList, EmptyString, FormTypeAdd, StatusCodeActive, StatusCodeDelete } from "utils/Constant";
import { ApiDeleteTransferPL, ApiGetTransferPLList } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import EditIcon from "assets/icon/EditIcon";
import { CreditCardNumberFormat, GetStatus, money } from "utils/helpers";
import RevisionIcon from "assets/icon/RevisionIcon";
import XIcon from "assets/icon/XIcon";
import FilterIcon from "assets/icon/FilterIcon";
import DatePicker from "components/Input/DatePicker";
import moment from "moment";
import Dropdown from "components/Input/Dropdown";

export default function TransferPL(){
    let navigate = useNavigate()

    const { data: transferPLList, fetch: apiGetTransferPLList } = useFetch(ApiGetTransferPLList)
    const { fetch: apiDeleteTransferPL } = useFetch(ApiDeleteTransferPL)
    
    const [status, setStatus] = useState(DropdownStatusList[1].value)
    const [isFilterOpen, setIsFilterOpen] = useState(false)

    const [transferPLDate, setTransferPLDate] = useState(new Date())
    
    const isFilterOpenClick = () => {
        setIsFilterOpen(!isFilterOpen)
    }

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState({isOpen: false})
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    useEffect(() => {
        setLoading({isOpen: true})
        
        getTransferPLList().then((data) => {
            setLoading({isOpen: false})
        })

        
    },[transferPLDate, status])

    // Function Api Call
    const getTransferPLList = async() => {
        let data = null

        await apiGetTransferPLList({
            data: {
                transferPLDate: transferPLDate,
                customerName: "",
                status: status
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                // setTransferPL(response.data)
                data = response.data
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })

        return data
    }
    const deleteTransferPL = async(transferPLId, status) => {
        await apiDeleteTransferPL({
            data: {
                transferPLId: transferPLId,
                status: status
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ 
                    isOpen: true, 
                    data: { 
                        onSuccess: async () => { 
                            setSuccessModal({  isOpen: false }) 
                        }
                    } 
                })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    // Button Click Handlers
    const addBtnClick = () => {
        navigate("/transfer-pl/form?transferPLId=&formType=" + FormTypeAdd)
    }
    const editBtnClick = (transferPLId) => {
        navigate("/transfer-pl/form?transferPLId=" + transferPLId + "&formType=Edit")
    }
    const deleteBtnClick = (transferPLId, status) => {
        setConfirmationModal({
            isOpen: true,
            data: {
                onSuccess: async () => {
                    setConfirmationModal({ isOpen: false })
                    setLoading({isOpen: true})

                    deleteTransferPL(transferPLId, status).then(() => {
                        getTransferPLList().then((data) => {
                            setLoading({isOpen: false})
                        })
                    })
                }
            }
        })
    }    

    return(
        <div className="flex flex-col gap-2">
            <div >
                <span className="font-semibold text-2xl">Transfer PL</span>
            </div>
            <hr />

            <div className="xl:hidden mt-5 flex justify-end">
                <button className="bg-black rounded-md flex gap-2 px-4 py-2" onClick={isFilterOpenClick}>
                    {isFilterOpen ? <XIcon className="fill-white w-6" /> : <FilterIcon className="fill-white w-6" />}
                    <span className="text-white">Filter</span>
                </button>
            </div>

            <div className={`flex flex-row gap-5 mt-5 ${isFilterOpen ? 'flex' : 'hidden xl:flex'}`}>
                <div className="flex flex-col gap-2 w-full sm:w-72">
                    <span>Transfer PL Date</span>
                        <div className="w-72">
                        <DatePicker className="w-full h-10 bg-white" value={transferPLDate} onChange={(date) => setTransferPLDate(date)} />
                    </div>
                </div>
                <div className="flex flex-col gap-2 w-full sm:w-72">
                    <span>Status</span>
                        <div className="w-48">
                        <Dropdown value={status} options={DropdownStatusList} onChange={(e) => setStatus(e.value)} placeholder="All" />
                    </div>
                </div>
            </div>

            <div className="flex w-full justify-end">
                <AddButton onClick={addBtnClick} />
            </div>
           
            <div className="hidden xl:block mt-5">                
                <table className="w-full border bg-white">
                    <thead>
                        <tr className="h-12">
                            <th className="font-semibold w-16">No</th>
                            <th className="font-semibold text-left px-2">Transfer PL Date</th>
                            <th className="font-semibold text-left px-2">Customer Name</th>
                            <th className="font-semibold text-left px-2">Bank</th>
                            <th className="font-semibold text-left px-2">Card Number</th>
                            <th className="font-semibold text-left px-2">Amount</th>
                            <th className="font-semibold text-left px-2">Remark</th>
                            <th className="font-semibold text-left px-2">Status</th>
                            <th className="font-semibold sm:w-24">Action</th>
                        </tr>
                    </thead>
                    <tbody className="border">
                        {transferPLList?.data?.length === 0 && (
                            <tr className="h-12">
                                <td colSpan={9} className="text-center">No Data Available</td>
                            </tr>
                        )}
                        {transferPLList?.data?.map((data, i) => {
                            return(
                                <tr className="my-2 row h-10 border-y hover:bg-slate-100" key={ i }>
                                    <td className="text-center">{ i+1 }</td>
                                    <td className="px-2">
                                        <span>{ moment(data.transferPLDate).format("DD MMM YYYY") }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.customerName.toUpperCase() }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.bankCode.toUpperCase() }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ CreditCardNumberFormat(data.cardNumber) }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>Rp { money(data.amount) }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.remark }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ GetStatus(data.status) }</span>
                                    </td>
                                    <td className="flex flex-col sm:flex-row justify-center py-2 gap-2 px-2">
                                        <button 
                                            className="button flex gap-2" 
                                            onClick={() => editBtnClick(data.transferPLId)}
                                        >
                                            <EditIcon className="w-4 fill-white" />
                                        </button>
                                        <button 
                                            className={`button flex gap-2 ${ data.status === StatusCodeDelete ? "hidden" : "block" }`} 
                                            onClick={() => deleteBtnClick(data.transferPLId, data.status)}
                                        >
                                            <TrashIcon className="w-4 fill-white" />
                                        </button>
                                        <button 
                                            className={`button flex gap-2 ${ data.status === StatusCodeActive ? 'hidden' : 'block' }`} 
                                            onClick={() => deleteBtnClick(data.transferPLId, data.status)}
                                        >
                                            <RevisionIcon className="w-4 fill-white" />
                                        </button>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colSpan={5} className="font-semibold p-2 text-right">Total Amount:</td>
                            <td className="font-semibold p-2">
                                Rp { transferPLList?.data?.length > 0 ? money(transferPLList?.data?.reduce((sum, record) => sum + parseFloat(record.amount), 0)) : 0 }
                            </td>
                            <td colSpan={3} className="text-right font-semibold p-2">
                                Total Data: { transferPLList?.data?.length ?? 0 }
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>

            {/* <div className="block xl:hidden mt-5">
                <div className="flex flex-col gap-3">
                    {customerCardList?.data?.listData?.map((data, i) => {
                        return(
                            <div className="bg-white p-3 border shadow flex justify-between">
                                <div className="flex flex-col">
                                    <label>{data.customerName.toUpperCase()}</label>
                                    <label>{data.cardNumber}</label>
                                    <label>{data.bankName + " - " + data.cardVendorName}</label>
                                </div>
                                <div className="flex flex-col justify-between">
                                    <button className="button flex gap-2" onClick={() => editBtnClick(data.customerCardId)}>
                                        <EditIcon className="w-4 fill-white" />
                                    </button>
                                    <button className={`button flex gap-2 ${ data.status === StatusCodeDelete ? "hidden" : "block" }`} onClick={() => deleteBtnClick(data.customerCardId, data.status)}>
                                        <TrashIcon className="w-4 fill-white" />
                                    </button>
                                    <button className={`button flex gap-2 ${ data.status === StatusCodeActive ? 'hidden' : 'block' }`} onClick={() => deleteBtnClick(data.customerCardId, data.status)}>
                                        <RevisionIcon className="w-4 fill-white" />
                                    </button>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div> */}

           

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}